import { Box } from '@mui/material';
import Chart from 'react-apexcharts';

import { GraphSkeleton } from '../progress';
import { ChartWrapperProps } from './ChartWrapper.types';

function ChartWrapper({ isLoading = false, ...props }: ChartWrapperProps) {
  if (isLoading)
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            height: '25rem',
            width: '100%',
            maxWidth: '50rem',
          }}
        >
          <GraphSkeleton />
        </Box>
      </Box>
    );
  return <Chart {...props} />;
}
export default ChartWrapper;
